<template>
  <card class="card-user">
    
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  export default {
    components: {
      Card
    },
    data () {
      return {
        
      }
    },
    methods: {
      getClasses (index) {
        
      }
    }
  }

</script>
<style>

</style>
